import { useCallback } from 'react';

import { useTracking } from '@change-corgi/core/react/tracking';

import { useTriggerTipSharingModal } from '../useTriggerTipSharingModal';

export type UseTipSharingButtonReturn = { actions: { handleTipClick: () => Promise<void> } };
export function useTipSharingButton(): UseTipSharingButtonReturn {
	const track = useTracking();

	const triggerTipSharingModal = useTriggerTipSharingModal();

	const handleTipClick = useCallback(async () => {
		void track('recommendations_tip_sharing_click');
		await triggerTipSharingModal();
	}, [track, triggerTipSharingModal]);

	return {
		actions: { handleTipClick },
	};
}
